import Vue from 'vue';
import { NuxtAppOptions } from '@nuxt/types';
import VueI18n, { LocaleMessages } from 'vue-i18n';

async function importTranslations(locale: string) {
  // eslint-disable-next-line no-useless-catch
  try {
    const [portalRootTranslations, portalCoreTranslations, portalPaywallTranslations, portalCustomerTranslations, portalMediaTranslations] =
      (await Promise.allSettled([
        import(/* webpackChunkName: "portal-root-[request]" */ `@root/locales/${locale}.json`),
        import(/* webpackChunkName: "portal-core-[request]" */ `@core/locales/${locale}.json`),
        import(/* webpackChunkName: "portal-paywall-[request]" */ `@paywall/locales/${locale}.json`),
        import(/* webpackChunkName: "portal-customer-[request]" */ `@customer/locales/${locale}.json`),
        import(/* webpackChunkName: "portal-Media-[request]" */ `@media/locales/${locale}.json`),
      ])) as { value?: LocaleMessages }[];
    return {
      ...portalRootTranslations.value,
      ...portalCoreTranslations.value,
      ...portalPaywallTranslations.value,
      ...portalCustomerTranslations.value,
      ...portalMediaTranslations.value,
    };
  } catch (e) {
    throw e;
  }
}

Vue.use(VueI18n);

export default async ({ app }: { app: NuxtAppOptions }) => {
  const { locale } = app.$channelConfig('settings');
  try {
    const translations = await importTranslations(locale);

    const i18n = new VueI18n({
      locale,
      fallbackLocale: locale,
      messages: {
        [locale]: translations,
      },
    });

    app.i18n = i18n;
  } catch (e) {
    const i18n = new VueI18n({ locale, fallbackLocale: locale });
    app.i18n = i18n;
    app.$sentry.captureException(e, { tags: { VueI18n: 'VueI18n plugin', 'process.server': process.server ? 'server' : 'client' } });
  }
};
